import Company from './Company';

export enum ProductionDefaultDateRule {
  Today = 'Today',
  NextCalendarDay = 'NextCalendarDay',
  NextWorkingDay = 'NextWorkingDay',
  LastUsed = 'LastUsed',
}

export interface WOConfiguration {
  // Define las propiedades específicas de WOConfiguration según tu DTO
}

export interface ProductionDefaultDateConfiguration {
  rule: ProductionDefaultDateRule;
  workingDays: number[];
}

export interface NavigationConfiguration {
  rootOrder: string[];
  hidden: string[];
  flattened: string[];
}

export interface SystemConfiguration {
  version: number;
  clientName: string;
  isCRM: boolean;
  isDataCapture: boolean;
  isPurchases: boolean;
  isInvoicing: boolean;
  isTimeTracking: boolean;
  isHolidays: boolean;
  isWorksManagement: boolean;
  isMaintenance: boolean;
  isProduction: boolean;
  isQualityValidation: boolean;
  wOConfiguration: WOConfiguration;
  navigation?: NavigationConfiguration | null;
  productionDefaultDate?: ProductionDefaultDateConfiguration | null;
  company: Company;
}

export type SystemModuleKey =
  | 'isDataCapture'
  | 'isPurchases'
  | 'isInvoicing'
  | 'isTimeTracking'
  | 'isHolidays'
  | 'isWorksManagement'
  | 'isMaintenance'
  | 'isProduction'
  | 'isQualityValidation';

export interface SystemModules {
  isPurchases: boolean;
  isInvoicing: boolean;
  isTimeTracking: boolean;
  isHolidays: boolean;
  isWorksManagement: boolean;
  isMaintenance: boolean;
  isProduction: boolean;
  isDataCapture: boolean;
  isQualityValidation: boolean;
}

export interface SystemModulesUpdate extends SystemModules {
  isCRM?: boolean;
}

const MODULES_ENABLED_BY_DEFAULT: SystemModuleKey[] = [
  'isPurchases',
  'isInvoicing',
  'isTimeTracking',
  'isHolidays',
  'isWorksManagement',
  'isMaintenance',
];

export const isModuleEnabled = (
  config: SystemConfiguration | undefined,
  moduleKey: SystemModuleKey
): boolean => {
  const value = config?.[moduleKey];
  if (value === undefined)
    return MODULES_ENABLED_BY_DEFAULT.includes(moduleKey);
  return value === true;
};

export type ModuleRequirement = SystemModuleKey | SystemModuleKey[];

export const isRequirementMet = (
  config: SystemConfiguration | undefined,
  requirement: ModuleRequirement | undefined
): boolean => {
  if (!requirement) return true;
  if (Array.isArray(requirement))
    return requirement.some(moduleKey => isModuleEnabled(config, moduleKey));
  return isModuleEnabled(config, requirement);
};
